var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React from 'react';
import { PatternBus, PatternBusEvents } from './pattern_bus';
var KEY_NIGHTMODE = 'patterns:darkmode';
export var ThemeContext = React.createContext({
    nightMode: false
});
var ThemeContextProvider = /** @class */ (function (_super) {
    __extends(ThemeContextProvider, _super);
    function ThemeContextProvider() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            nightMode: localStorage.getItem(KEY_NIGHTMODE) === 'true'
        };
        _this.observer = function () { return __awaiter(_this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                this.setState({ nightMode: !this.state.nightMode }, function () {
                    document.body.className = _this.state.nightMode ? 'bp3-dark' : '';
                    localStorage.setItem(KEY_NIGHTMODE, "" + _this.state.nightMode);
                });
                return [2 /*return*/];
            });
        }); };
        return _this;
    }
    ThemeContextProvider.prototype.componentDidMount = function () {
        document.body.className = this.state.nightMode ? 'bp3-dark' : '';
        PatternBus.instance.observe(PatternBusEvents.NIGHT_MODE_TOGGLE, this.observer);
    };
    ThemeContextProvider.prototype.componentWillUnmount = function () {
        PatternBus.instance.cancel(PatternBusEvents.NIGHT_MODE_TOGGLE, this.observer);
    };
    ThemeContextProvider.prototype.render = function () {
        return React.createElement(ThemeContext.Provider, { value: { nightMode: this.state.nightMode } }, this.props.children);
    };
    return ThemeContextProvider;
}(React.Component));
export { ThemeContextProvider };
//# sourceMappingURL=theme_context.js.map